import { useLocation } from "react-router-dom";
import MainLayout from "./MainLayout";
import { Outlet } from "react-router-dom";

const MainLayoutWrapper = () => {
	const location = useLocation();

	// Get layout settings based on URL patterns
	const getLayoutSettings = (pathname) => {
		// Exact matches for static pages
		const staticPages = {
			"/": {
				heroShowText: true,
				heroHeading: "Highest Rated Driving School Canberra",
				heroTextContent:
					"Welcome to Steer Smart Driving School Canberra, a trusted choice for driving lessons in Canberra. Our ACT-accredited instructors provide clear, practical guidance to help you learn to drive with confidence. Whether you’re starting out or looking to improve your skills, we offer personalised automatic and manual driving lessons suited to your pace and needs.",
			},
			"/packages": {
				heroImageName: "banner1-notext",
				heroShowText: true,
				heroHeading: "Our Packages",
			},
			"/contact": {
				heroShowText: true,
				heroHeading: "Contact Us",
			},
			"/services": {
				heroImageName: "banner1-notext",
				heroImageExtension: "jpg",
				heroShowText: true,
				heroHeading: "Services We Offer",
			},
			"/checkout": {
				heroShowText: true,
				heroHeading: "Checkout",
			},
			"/about": {
				heroShowText: true,
				heroHeading: "About Us",
			},
			"/articles": {
				heroShowText: true,
				heroHeading: "Articles",
			},
		};

		// Check for exact match first
		if (staticPages[pathname]) {
			return staticPages[pathname];
		}

		// Handle dynamic routes by URL pattern
		if (pathname.startsWith("/services/") && pathname !== "/services") {
			const serviceName = pathname
				.split("/services/")[1]
				.split("-")
				.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
				.join(" ");

			return {
				heroShowText: true,
				heroHeading: serviceName,
			};
		}

		if (pathname.startsWith("/articles/") && pathname !== "/articles") {
			// const slug = pathname.split("/blogs/")[1];
			// const heroHeading = slug
			// 	.split("-")
			// 	.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			// 	.join(" ");

			return {
				heroShowText: true,
				heroHeading: "",
			};
		}

		if (pathname.startsWith("/packageinfo/")) {
			const packageName = pathname
				.split("/packageinfo/")[1]
				.split("-")
				.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
				.join(" ");

			return {
				heroShowText: true,
				heroHeading: `${packageName} Package`,
			};
		}

		// Default for unmatched routes (let React Router handle 404)
		return {
			heroShowText: true,
			heroHeading: "Page Not Found",
		};
	};

	const currentSettings = getLayoutSettings(location.pathname);

	return (
		<MainLayout
			heroShowText={currentSettings.heroShowText}
			heroHeading={currentSettings.heroHeading}
			heroTextContent={currentSettings.heroTextContent}
			heroImageName={currentSettings.heroImageName}
			heroImageExtension={currentSettings.heroImageExtension}
		>
			<Outlet />
		</MainLayout>
	);
};

export default MainLayoutWrapper;
